import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.markercluster";
import useWindyFetch from "../../hooks/useDataFetch";
import useIconInit from "../../hooks/useIconInit";

const AQIMarkers = () => {
  const map = useMap();

  const { airQualityData, fetchAirQualityByCity } = useWindyFetch();
  const { createCustomIcon, markerClusterGroup } = useIconInit();

  useEffect(() => {
    if (!map) return;
    fetchAirQualityByCity();
  }, [map]);

  useEffect(() => {
    if (!map || !airQualityData?.length) return;

    airQualityData.forEach((item) => {
      const aqius = item?.aqi;
      const marker = L.marker(
        { lat: item?.lat, lon: item?.lon },
        {
          icon: createCustomIcon(aqius),
        }
      );
      marker.aqius = aqius;
      marker.bindPopup(`<b>${aqius} US AQI</b><br>${item?.city || ''}`);
      markerClusterGroup.addLayer(marker);
    });

    map.addLayer(markerClusterGroup);

    return () => {
      map.removeLayer(markerClusterGroup);
    };
  }, [map, airQualityData]);

  return null;
};

export default AQIMarkers;
